import tx from "@/core/app/tx";

const items = [
    {id: 1, nameTx: 'Cancelled', name: 'Cancelled', criteria: {eq: 1}},
    {id: 20, nameTx: 'Pending', name: 'Pending', criteria: {eq: 20}},
    {id: 30, nameTx: 'In Workshop', name: 'In Workshop', criteria: {eq: 40}},
    {id: 50, nameTx: 'Done', name: 'Done', criteria: {eq: 50}}, //proceso de checkout
    {id: 60, nameTx: 'Finalized', name: 'Finalized', criteria: {eq: 60}},


];
const itemsForList = [
    {id: 1000, nameTx: 'All', name: 'All', criteria: {gt: 0}},
    {id: 1001, nameTx: 'Active + Finalized', name: 'Active', criteria: {gt: 1}},
    {id: 1003, nameTx: 'Active', name: 'Active', criteria: {gt: 1, lt: 60}},
    {id: 1, nameTx: 'Cancelled', name: 'Cancelled', criteria: {eq: 1}},
    {id: 20, nameTx: 'Pending', name: 'Pending', criteria: {eq: 20}},
    {id: 30, nameTx: 'In Workshop', name: 'In Workshop', criteria: {eq: 40}},
    {id: 50, nameTx: 'Done', name: 'Done', criteria: {eq: 50}}, //proceso de checkout
    {id: 60, nameTx: 'Finalized', name: 'Finalized', criteria: {eq: 60}},


];
const values = Object.freeze({
    // NEW  : 0 , Uso interno
    CANCELLED: 1,
    PENDING: 20,
    IN_WORKSHOP: 30,
    DONE: 50,
    FINALIZED: 60,
    LIST_ALL: 1000,
    LIST_ACTIVE: 1003,
    LIST_ACTIVE_FINALIZED: 1002
});

function getName(status) {
    switch (status) {
        case values.CANCELLED  :
        case "1" :
            return items[0].name;
        case values.PENDING     :
        case "20":
            return items[1].name;
        case values.IN_WORKSHOP     :
        case "30" :
            return items[2].name;
        case values.DONE  :
        case "50"  :
            return items[3].name;
        case values.FINALIZED  :
        case "60" :
            return items[4].name;
        default:
            return status;
    }
}

function translateNames() {
    translateNamesForList();
    for (let item of items) {
        item.name = tx.t(item.nameTx);
    }
}


function translateNamesForList() {
    for (let item of itemsForList) {
        item.name = tx.t(item.nameTx);
    }
}

function getItems() {
    return items
}

function getItemsForList() {
    return itemsForList
}

export default {
    getItems, getItemsForList, getName, translateNames, values
}

